<div id="myModal" class="modal">
  <!-- Modal content -->
  <div class="modal-content ">
    <span class="close" (click)="closePopUp()" *ngIf="responseMessage !== 'You have already purchased this plan!'">
      &times;
    </span>
    <p class="success user-msg" [innerHTML]="responseMessage"> </p>
    <div *ngIf="responseMessage == 'You have already purchased this plan!'" class="text-center">
      <a  class="btn" href="/">
        Click Here For Home
      </a>
    </div>
    <div *ngIf="responseMessage == 'Account already created !!'" class="text-center" style="margin-top: 25px;">
      <a  class="btn" href="/">
        Click Here For Home
      </a>
    </div>
  </div>
</div>
